import { createActions } from 'redux-actions';
import { CorporateHealthOrder } from '@models/CorporateHealthOrder';
import { GetCorporateHealthOrderByUsernameParams, GetCorporateHealthOrderUserRemainingBenefitsParams, GetCorporateUserByUsernameParams } from '@apis/CorporateHealthOrderApi';
import { CorporateHealthClaim } from '@models/CorporateHealthClaim';
import { CreateCorporateHealthClaimParams } from '@apis/CorporateHealthClaimApi';
import { CorporateUser } from '@models/User';
import { CorporateHealthOrderUserRemainingBenefit } from '@models/CorporateHealthOrderUserRemainingBenefit';
import { FormikErrors } from 'formik';
import { FormValues } from './schema';

export type State = {
  errors?: FormikErrors<FormValues>;
  policy?: CorporateHealthOrder | null;
  user?: CorporateUser | null;
  corporateHealthClaim?: CorporateHealthClaim | null;
  corporateHealthOrderUserRemainingBenefits?: CorporateHealthOrderUserRemainingBenefit[];
};

export type PolicyFetchPayload = GetCorporateHealthOrderByUsernameParams;
export type UserFetchPayload = GetCorporateUserByUsernameParams;
export type CorporateHealthOrderUserRemainingBenefitsFetchPayload = GetCorporateHealthOrderUserRemainingBenefitsParams;
export type CorporateHealthClaimCreatePayload = CreateCorporateHealthClaimParams;
export type StateUpdatePayload = Partial<State>;

export const {
  policyFetch,
  userFetch,
  corporateHealthOrderUserRemainingBenefitsFetch,
  corporateHealthClaimCreate,

  stateUpdate,
} = createActions(
  'POLICY_FETCH',
  'USER_FETCH',
  'CORPORATE_HEALTH_ORDER_USER_REMAINING_BENEFITS_FETCH',
  'CORPORATE_HEALTH_CLAIM_CREATE',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_POLICY_CLAIM_CORPORATE_HEALTH_POLICY_CLAIM',
  },
);
